//#region Imports
import * as React from "react";
import { IAnalyticsContextValue } from "../IAnalyticsContextValue";
//#endregion

export const AnalyticsContext = React.createContext<IAnalyticsContextValue>(null!);

if (__DEV__) {
  AnalyticsContext.displayName = "AnalyticsContext";
}
